import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddecc23a"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["type", "value", "placeholder"]



type InputEvent = Omit<Event, 'target'> & { target: HTMLInputElement };


export default /*#__PURE__*/_defineComponent({
  props: {
    class: null,
    type: null,
    value: null,
    placeholder: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'input', e: InputEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  class?: string;
  type?: string;
  value?: string;
  placeholder?: string;
}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("input", {
    type: props.type,
    class: _normalizeClass([`Input`, props.class]),
    value: props.value,
    placeholder: props.placeholder,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('input', $event as InputEvent)))
  }, null, 42, _hoisted_1))
}
}

})